<template>
  <div style="background: #f4f4f4; width: 100%; padding-bottom: 20px">
    <div style="position: relative">
      <img src="../../../../assets/img/yun.jpg" height="300" width="100%" />
    </div>
    <div style="padding: 20px 0">
      <span style="font-size: 16px; font-weight: bold">询价找车</span>
    </div>
    <div style="display: flex; height: 100%">
      <div class="top_right">
        <div
          class=""
          style="padding: 0 20px; box-sizing: border-box; width: 100%"
        >
          <div
            class="d_f"
            style="justify-content: space-between; align-items: center"
          >
            <div style="margin: 20px 0 0 0; width: 48%">
              <div
                style="
                  display: inline-block;
                  vertical-align: middle;
                  width: 67px;
                  margin-right: 15px;
                "
              >
                <span style="color: red; vertical-align: text-top">*</span>
                联系人
              </div>
              <input v-model="postData.contacts" placeholder="请输入联系人" @input="() => {
                postData.contacts = postData.contacts.trim()
              }" />
            </div>
            <div style="margin: 20px 0 0 0; width: 48%">
              <div
                style="
                  display: inline-block;
                  vertical-align: middle;
                  width: 67px;
                  margin-right: 15px;
                "
              >
                <span style="color: red; vertical-align: text-top">*</span>
                联系电话
              </div>
              <input v-model="postData.phone" type="number" placeholder="请输入联系电话" />
            </div>
          </div>
          <div
            class="d_f"
            style="justify-content: space-between; align-items: center"
          >
            <div style="margin: 20px 0 0 0; width: 48%">
              <div
                style="
                  display: inline-block;
                  vertical-align: middle;
                  width: 67px;
                  margin-right: 15px;
                "
              >
                <span style="color: red; vertical-align: text-top">*</span>
                装货地
              </div>
              <input
                v-model="postData.deliveryPlace"
                placeholder="请输入装货地址"
                @input="() => {
                  postData.deliveryPlace = postData.deliveryPlace.trim()
                }"
              />
            </div>
            <div style="margin: 20px 0 0 0; width: 48%">
              <div
                style="
                  display: inline-block;
                  vertical-align: middle;
                  width: 67px;
                  margin-right: 15px;
                "
              >
                <span style="color: red; vertical-align: text-top">*</span>
                卸货地
              </div>
              <input
                v-model="postData.dischargePlace"
                placeholder="请输入卸货地址"
                @input="() => {
                  postData.dischargePlace = postData.dischargePlace.trim()
                }"
              />
            </div>
          </div>
          <div
            class="d_f"
            style="justify-content: space-between; align-items: center"
          >
            <div style="margin: 20px 0 0 0; width: 48%">
              <div
                style="
                  display: inline-block;
                  vertical-align: middle;
                  width: 67px;
                  margin-right: 15px;
                "
              >
                <span style="color: red; vertical-align: text-top">*</span>
                吨位
              </div>
              <input v-model="postData.tonnage"
              type="numer"
              @input="() => {
                if (parseFloat(postData.tonnage) < 0) {
                  postData.tonnage = Math.abs(parseFloat(postData.tonnage))
                } else if (postData.tonnage.length === 0) {
                } else {
                  postData.tonnage = parseFloat(postData.tonnage)
                }
              }"
              placeholder="0.00" />
            </div>
            <div style="margin: 20px 0 0 0; width: 48%">
              <div
                style="
                  display: inline-block;
                  vertical-align: middle;
                  width: 67px;
                  margin-right: 15px;
                "
              >
                <span style="color: red; vertical-align: text-top">*</span>
                品种
              </div>
              <input v-model="postData.productType" placeholder="请输入品种"
              @input="() => {
                postData.productType = postData.productType.trim()
              }" />
            </div>
          </div>
          <div
          style="margin: 20px 0 0 0"
          class="d_f remark"
          :data-length="postData.remark.length"
          data-max="200">
            <div
              style="
                display: inline-block;
                vertical-align: middle;
                width: 66px;
                margin-right: 15px;
                position: relative;
              "
            >
              备注
            </div>
            <textarea
              rows="5"
              style="width: calc(100% - 100px)"
              class="allTextarea"
              v-model="postData.remark"
              @input="() => {
                if (postData.remark.length > 200) {
                  postData.remark = postData.remark.substring(0, 200)
                }
              }"
              placeholder="请输入备注"
            />
          </div>
          <div style="width: 100%; text-align: center; margin-top: 20px">
            <button class="helpfandcar" @click="addTransport">帮我找车</button>
          </div>
          <div class="w100" style="padding-bottom: 20px">
            <img
              src="../../../../assets/img/yun2.jpg"
              style="width: 100%"
              alt=""
            />
          </div>
        </div>
        <!--             <div style="width: 40%;">-->
        <!--                   <div style="text-align: center; margin-top: 20%;">-->
        <!--                        <img src="../../../../assets/img/ewm.png" height="100" width="100"/>-->
        <!--                   </div>-->
        <!--                   <div style="text-align: center;margin-top: 10px;">-->
        <!--                     <div style="font-size: 16px;font-weight: bold;">百钢商城|钢铁电商</div>-->
        <!--                     <span style="font-size: 14px;font-weight: bold; color: red;">微信下单更便捷</span>-->
        <!--                   </div>-->
        <!--             </div>-->
      </div>
      <div class="" style="width: 47%; margin-left: 3%">
        <div style="text-align: center; padding: 3%; background: white">
          <span style="font-size: 16px; color: red; font-weight: normal"
            >实时数据</span
          >
        </div>
        <div class="lun_fa">
          <!-- <marquee direction="up"> -->
          <ul
            style="
              position: relative;
              overflow: hidden;
              position: absolute;
              width: 100%;
            "
          >
            <li :key="index" v-for="(item, index) in jiagong1">
              <div class="split_4">
                <span style="font-size: 14px">{{ item.name }}</span>
              </div>
              <div class="split_4">
                <span style="font-size: 14px">{{ item.type }}</span>
              </div>
              <div class="split_4">
                <span style="font-size: 14px">{{ telFormat(item.phone) }}</span>
              </div>
              <div class="split_4">
                <span
                  :style="{
                    color:
                      item.status === '已完成' || item.status === '已成交'
                        ? 'red'
                        : '',
                  }"
                  style="font-size: 14px"
                  >{{ item.status }}</span
                >
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div style="padding: 20px 0">
      <span style="font-size: 16px; font-weight: bold"> 优质线路推荐 </span>
    </div>
    <div class="lun_fa2" style="display: flex">
      <ul
        style="
          position: relative;
          display: flex;
          background: #f4f4f4;
          width: 100%;
        "
      >
        <li
          v-for="(item, index) in jiagong2"
          :key="index"
          style="background: white"
        >
          <div
            style="
              border-left: #f4f4f4 1px solid;
              text-align: center;
              width: calc(1300px / 5);
            "
          >
            <div style="padding-top: 10px">
              {{ item.name }}
            </div>
            <div>
              <img
                src="../../../../assets/img/jiantou.png"
                height="32"
                width="20"
              />
            </div>
            <div style="padding-bottom: 10px">
              {{ item.name2 }}
            </div>
            <div style="padding-bottom: 10px">
              <span style="color: red"> {{ item.price }}</span>
            </div>
            <div style="padding-bottom: 10px">
              <span style="font-size: 14px; color: #a5a5a5">
                {{ item.tax }}</span
              >
            </div>
          </div>
        </li>
      </ul>
      <!--                <div style="position:absolute;line-height: 133px;filter:alpha(opacity=50);-moz-opacity: 0.5;opacity: 0.5;">-->
      <!--                  <button style="border: none;" @click="onLeft" id="l">-->
      <!--                    <img src="../../../../assets/img/left.png" height="50" width="20"/>-->
      <!--                  </button>-->
      <!--                </div>-->
      <!--                <div style="position: absolute;line-height: 133px;filter:alpha(opacity=50);-moz-opacity: 0.5;opacity: 0.5; right: 0px;">-->
      <!--                  <button style="border: none; " @click="onRight" id="r">-->
      <!--                    <img src="../../../../assets/img/right.png" height="50" width="20"/>-->
      <!--                  </button>-->
      <!--                </div>-->
    </div>
  </div>
</template>

<script>
import pubilshSet from '../../../../assets/js/pubilshSet'

export default {
  name: 'myTransport',
  props: ['from'],
  data () {
    return {
      jiagong1: [],
      jiagong2: [],
      jiagong3: [],
      postData: {
        contacts: '', // 联系人
        deliveryPlace: '', // 发货地
        dischargePlace: '', // 卸货地
        memberId: window.localStorage.getItem('memberId'), // 会员id
        phone: '', // 手机号
        productType: '', // 产品类型
        remark: '', // 备注
        tonnage: '' // 吨位
      }
    }
  },
  created () {
    if (this.from === 'index') {
      document.title = '帮我运 | 百钢商城 | 钢铁电商，百炼成钢'
    }
    this.getData()
  },
  methods: {
    telFormat (tel) {
      tel = String(tel)
      return tel.substr(0, 3) + '****' + tel.substr(7)
    },
    getData () {
      this.$axiox.get('/baigang/app/home/getConfig/yun1').then(p => {
        this.jiagong1 = JSON.parse(p.data.paramValue)
        this.jiagong1.forEach(item => {
          this.jiagong1.push(item)
        })
      })
      this.$axiox.get('/baigang/app/home/getConfig/yun2').then(p => {
        this.jiagong2 = JSON.parse(p.data.paramValue)
        this.jiagong2.forEach(item => {
          this.jiagong2.push(item)
        })
      })
    },
    addTransport () {
      if (
        this.$commonJs.checkIfEmpty(this.postData, [
          'contacts',
          'deliveryPlace',
          'dischargePlace',
          'phone',
          'productType',
          'tonnage'
        ])
      ) {
        return
      }
      console.log(this.postData)
      this.$axiox
        .post('/baigang/shop/helpDelivery/add', this.postData)
        .then((msg) => {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '新增成功',
            stayTime: 5
          })
          this.postData = {
            contacts: '', // 联系人
            deliveryPlace: '', // 发货地
            dischargePlace: '', // 卸货地
            memberId: window.localStorage.getItem('memberId'), // 会员id
            phone: '', // 手机号
            productType: '', // 产品类型
            remark: '', // 备注
            tonnage: '' // 吨位
          }
        })
    },
    toCenterUrl (page) {
      window.open(pubilshSet.userCenterHostUrl + page)
    },
    onRight () {
      document.getElementById('r')
    },
    onLeft () {
      document.getElementById('l')
    }
  }
}

</script>
<style scoped>
.top_right {
  width: 50%;
  background: white;
  display: flex;
}
select {
  padding: 10px 0;
  color: #a5a5a5;
  width: 202px;
  border: 1px solid;
  display: inline-block;
  vertical-align: middle;
}
input {
  padding: 10px 5px;
  color: #a5a5a5;
  width: 190px;
  border: 1px solid;
  display: inline-block;
  vertical-align: middle;
}
.split_4 {
  display: inline-block;
  vertical-align: middle;
  width: 22%;
  margin-left: 2%;
  /*margin-top: 20px;*/
  padding: 10px 0;
  height: 20px;
}
.lun_fa {
  background: white;
  overflow: hidden;
  text-align: center;
  position: relative;
  height: calc(89% + 4px);
}
.lun_fa > ul {
  animation: 15s dong infinite;
}
.lun_fa > ul:hover {
  animation-play-state: paused;
}
.lun_fa > ul > li:nth-child(2n) {
  background-color: #f9f9f9;
}

@keyframes dong {
  0% {
    /* top: 0; */
  }
  20% {
    /* top: -40px; */
    transform: translate(0, calc(-10%));
  }
  40% {
    /* top: -80px; */
    transform: translate(0, calc(-20%));
  }
  60% {
    /* top: -120px; */
    transform: translate(0, calc(-30%));
  }
  80% {
    /* top: -160px; */
    transform: translate(0, calc(-40%));
  }
  100% {
    /* top: -200px; */
    transform: translate(0, calc(-50%));
  }
}
.lun_fa2 {
  background: white;
  overflow: hidden;
  text-align: center;
  position: relative;
}
.lun_fa2 > ul {
  animation: 15s dong2 infinite;
}
.lun_fa2 > ul:hover {
  animation-play-state: paused;
}

@keyframes dong2 {
  0% {
    left: 0;
  }
  20% {
    left: -240px;
  }
  40% {
    left: -480px;
  }
  60% {
    left: -720px;
  }
  80% {
    left: -960px;
  }
  100% {
    left: -1200px;
  }
}
.helpfandcar {
  background: #d71e1e;
  font-size: 16px;
  padding: 5px 40px;
  border: none;
  border-radius: 5px;
  color: white;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/page/mySteelMall/myTransport.vue